var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check-mark-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.921,
    height: 19.922,
    viewBox: "0 0 19.921 19.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18814",
    "data-name": "Path 18814",
    d: "M9.964,0a9.961,9.961,0,1,0,9.961,9.96A9.972,9.972,0,0,0,9.964,0Zm4.311,7.92L9.058,13.136a.8.8,0,0,1-1.135,0L5.654,10.868A.8.8,0,0,1,6.789,9.732l1.7,1.7,4.65-4.65A.8.8,0,1,1,14.275,7.92Z",
    transform: "translate(-0.003)",
    fill: "#28a745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7eb9d04a782a5ccb9c935a3b5282911f.svg";
export { ForwardRef as ReactComponent };